<adapt-menu #menuComponent
            [items]="itemMenu"
            data-test="item-action-menu"></adapt-menu>
<ng-template #labelMenuTemplate>
    <adapt-recent-label-submenu-content [item]="item"
                                        (itemClicked)="menuComponent.refresh()"></adapt-recent-label-submenu-content>
</ng-template>
